import { cleanupPwaServiceWorker } from "@/utils/pwaServiceWorkerCleanup";
import { memo, useEffect } from "react";

function PWAServiceWorkerCleanup() {
  useEffect(() => {
    cleanupPwaServiceWorker().catch(() => null);
  }, []);

  return null;
}

export default memo(PWAServiceWorkerCleanup);
